import { RichText } from "@wordpress/block-editor";
import { useRef, useState } from "@wordpress/element";
import { useEffect } from "@wordpress/element";
import { produce } from "immer";

import Settings from "./Settings";
import Style from "./Style";
import "./style.scss";
import View from "./View";
import VideoBox from "./VideoBox";

const Edit = ({ attributes, setAttributes, className }) => {
  const { uniqueId, align, videos } = attributes;
  const [isPremium, setIsPremium] = useState(ytpPlayer.is_premium);

  const updateVideo = (key, value, index) => {
    console.log(key, value, index);
    setAttributes({
      videos: produce(videos, (draft) => {
        draft[index][key] = value;
      }),
    });
  };

  return (
    <>
      {isPremium ? (
        <>
          {" "}
          <Settings attributes={attributes} setAttributes={setAttributes} updateVideo={updateVideo} />
          <View attributes={attributes} updateVideo={updateVideo} VideoBox={VideoBox} className={className}></View>
        </>
      ) : (
        <>
          <h2 style={{ textAlign: "center", padding: "50px 0" }}>sorry, {"it's"} a premium block</h2>
        </>
      )}
      {/* <Style attributes={attributes} /> */}
    </>
  );
};

export default Edit;
